import { CAccordionSummary } from "./AccordianStyle";
import Typography from "@material-ui/core/Typography";
import { MdExpandMore } from "react-icons/md";
import Modal from "../../Modal/Modal";
import { Accordion, AccordionDetails, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Column, Bold, Value } from "../../../style/Dashboard";
import React, { useState } from "react";
import UpArrow from "../../../assets/AssetArrow.png";
import "./Accordian.css"
import Horizonatl from '../../../assets/Ads/Horizontal.jpeg'
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    // fontSize: theme.typography.pxToRem(16),
    fontWeight: "500",
    color: "#4678ED",
    fontSize: "15px",
    marginLeft: "0px",
    // backgroundColor: "#f9f9f9",
    padding: "0px !important",
    marginTop: "5px",
    marginBottom: "5px",
    fontFamily: "work sans !important",
    border: '30px'
  },
  AccordionD: {
    display: "unset !important",
    padding: "0 !important",
    backgroundColor: "#ffffff !important"

  }, content: {
    backgroundColor: "#ffffff"
  }
}));

const Heading = [
  "Demographics",
];
const CustomeHeading = [
  "Insurance",
  "Vitals",
  "Medical Problems",
  "Allergies",
];

export default function NewAccordion({ reactCreative }) {
  const classes = useStyles();
  const [openHeading, setHeading] = useState("panel-0");
  var panel = 0;

  function generateWeekAccordion() {
    return (
      <div>
        <div className="dashboardAccordian accordianSection">
          {Heading.map(
            (head) => (
              <Accordion
                className={classes.heading}
                head={openHeading}
                expanded={openHeading === "panel-" + panel++}
                //onClick={() => handleAccordClick(head)}
                // key=fghj
                style={{ padding: "0px" }}
              >
                <CAccordionSummary
                  className={classes.Accordion}
                  expandIcon={<img src={UpArrow} style={{ marginLeft: "auto", marginTop: "0px", width: "13.5px" }} />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>
                    {" "}
                    {head}
                    <span style={{ float: "right" }}>
                      {" "}
                      {
                        <Modal />
                      }
                    </span>
                  </Typography>
                </CAccordionSummary>
                <AccordionDetails style={{ backgroundColor: "#ffffff", padding: '10px 15px' }} className={classes.AccordionD}>
                  {" "}
                  <Container style={{ backgroundColor: "#ffffff", paddingTop: '40px', overflow: "auto" }}>
                    <Column>
                      <Value>Name:</Value> <Bold>Phil Belford</Bold>{" "}
                    </Column>
                    <Column>
                      <Value>Marital Status:</Value> <Bold>Single</Bold>{" "}
                    </Column>
                    <Column>
                      <Value>Externam ID:</Value> <Bold>9034906</Bold>{" "}
                    </Column>
                  </Container>
                  <Container style={{ backgroundColor: "#ffffff", overflow: "auto" }}>
                    <Column>
                      <Value>DOB:</Value> <Bold>1972-02-09</Bold>{" "}
                    </Column>
                    <Column>
                      <Value>User Defind:</Value> <Bold>True</Bold>{" "}
                    </Column>
                    <Column>
                      <Value>Sex:</Value> <Bold>Male</Bold>{" "}
                    </Column>
                  </Container >
                  <Container style={{ backgroundColor: "#ffffff", overflow: "auto" }}>
                    <Column>
                      <Value>S.S</Value> <Bold>7879025397</Bold>{" "}
                    </Column>
                    <Column>
                      <Value>Billing Note:</Value> <Bold>Medicaid</Bold>{" "}
                    </Column>
                    <Column>
                      <Value>License ID:</Value> <Bold>8674729</Bold>{" "}
                    </Column>
                  </Container>
                </AccordionDetails>
              </Accordion>
            ))
          }
        </div>

        <Grid container spacing={3}>
          {
            reactCreative &&
            <Grid item md={3} xs={12}>
              <div className={`accordianGridp ${reactCreative ? '' : 'noIframe'}`}>
                <div className="imageAc">
                  {reactCreative && (
                    <div className="responsiveMargin" style={{ maxWidth: '300px', minHeight: '250px',}}>
                      <iframe
                        title="iframe"
                        srcDoc={reactCreative}
                        style={{
                          width: '100%',
                          height: '100%',
                          maxWidth: '100%',
                          minHeight: '250px',
                          marginBottom:"30px"
                        }}
                        frameBorder="0"
                        scrolling="no"
                      />
                    </div>

                  )}
                </div>
              </div>
            </Grid>
          }
          <Grid item md={`${reactCreative ? 9 : 12}`} xs={12}>
            <div className="gridAc">
              <div className="dashboardAccordian-2 accordianSection">
                {
                  CustomeHeading.map(
                    (head) => (
                      <Accordion
                        className={classes.headingCustome}
                        head={openHeading}
                        expanded={openHeading === "panel-" + panel++}
                        //onClick={() => handleAccordClick(head)}
                        style={{ padding: "0px" }}
                      >
                        <CAccordionSummary
                          className={classes.Accordion}
                          expandIcon={<img src={UpArrow} style={{ marginLeft: "auto", marginTop: "0px", width: "13.5px" }} />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography className={classes.headingCustome} style={{ color: "#4678ED", fontWeight: "500", fontSize: "15px", fontFamily: "work sans" }}>
                            {" "}
                            {head}
                            <span style={{ float: "right" }}>
                              {" "}
                              {
                                <Modal />
                              }
                            </span>
                          </Typography>
                        </CAccordionSummary>
                      </Accordion>
                    ))
                }
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }

  function handleAccordClick(head) {
    if (openHeading === head) setHeading("");
    if (openHeading !== head) setHeading(head);
  }

  return <div className="App">{generateWeekAccordion()}</div>;
}
